/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
      // A mouse or finger press shouldn't take focus: the focus guard in app.js would move it onto a product link after the redraw.
      this.addEventListener('mousedown', (e) => e.preventDefault());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!e.repeat) this.click();
        }
      });
    }
    onClickHandler(event) {
      event.preventDefault();
      // Lines renumber after a delete, so a second press while the first is running would remove the next line.
      if (this.closest('.cart-disabled, .thb-loading')) return;
      const { index, key } = this.dataset;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(index, '0', key);
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index, key } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
